import React, { useState, useEffect } from 'react';
import S from 'StyledTotalBonus.js';
import { translation } from 'helpers/utilsHelper';

const TotalBonus = ({
  totalBonus: { currentBonusValue = 0, futureBonusValue = 0, minOutcomeOdds = 0 },
  bonus,
  isMultiCoupon = false,
  multiCouponSize,
}) => {
  const [bonusIncrease, setBonusIncrease] = useState(0);

  useEffect(() => {
    futureBonusValue > 0
      ? setBonusIncrease(futureBonusValue - currentBonusValue)
      : setBonusIncrease(0);
  }, [currentBonusValue, futureBonusValue]);

  const multiCouponBonus = isMultiCoupon ? Math.round((bonus * multiCouponSize) * 100) / 100 : null;

  return (
    <>
      {bonus && bonus > 0 && (
        <S.TotalBonusWrapper className="total-bonus-wrapper">
          <S.TotalBonusTitle
            dangerouslySetInnerHTML={{
              __html: translation('betSlip_customBonusTitle', [multiCouponBonus ?? bonus]),
            }}
          ></S.TotalBonusTitle>
          {minOutcomeOdds > 0 && bonusIncrease > 0 && (
            <S.TotalBonusAdditionalInfo
              dangerouslySetInnerHTML={{
                __html: translation('betSlip_customBonusAdditionalInfo', [
                  bonusIncrease,
                  minOutcomeOdds,
                ]),
              }}
            ></S.TotalBonusAdditionalInfo>
          )}
        </S.TotalBonusWrapper>
      )}
    </>
  );
};

export default TotalBonus;
